import * as React from "react";

function LumiteIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 85 27"
    >
      <defs>
        <clipPath>
          <rect width="85" height="27" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-lumite)">
        <path
          data-name="Path 7119"
          d="M-32.12-1.5c-.4,0-.55-.264-.462-.66l2.684-10.78c.286-1.276.638-1.43,2.068-1.54l.22-.924h-7.37l-.22.924c1.386.11,1.606.264,1.32,1.54l-2.6,10.472c-.308,1.254-.638,1.43-2.068,1.54L-38.786,0h11.792l2.838-4.466-.66-.462C-26.774-3.014-29.414-1.5-31.46-1.5Zm16.346-6.27h.682c.4,0,.462.2.352.66l-1.21,4.928a4.345,4.345,0,0,1-2.112.638c-.814,0-1.276-.418-1.012-1.474l1.848-7.458H-18.5L-22.33-8.624l-.22.858h.682c.4,0,.462.2.352.66l-.99,4C-23.21-.242-21.472.33-19.844.33A8.222,8.222,0,0,0-16.324-.7L-16.588.33A31.483,31.483,0,0,1-11.858,0l.242-.924c-.99-.11-1.122-.308-.968-.968l2.134-8.58h-1.276l-3.828,1.848ZM2.024,0l.242-.924c-.968-.11-1.122-.308-.968-.968L2.6-7.04a6.561,6.561,0,0,0,.132-.88A4.353,4.353,0,0,1,4.906-8.6c.814,0,1.276.418,1.012,1.474L4.158,0H8.8l.242-.924c-.99-.11-1.122-.308-.968-.968L9.35-7.04c.726-2.86-1.034-3.432-2.662-3.432a8.2,8.2,0,0,0-4.07,1.386c-.4-1.1-1.584-1.386-2.706-1.386a8.134,8.134,0,0,0-3.52,1.034l.264-1.034H-4.62L-8.448-8.624l-.22.858h.682c.4,0,.484.2.352.66l-1.3,5.214c-.154.66-.4.858-1.408.968L-10.582,0h5.83l.242-.924c-.99-.11-1.122-.308-.968-.968l1.5-6.072A4.345,4.345,0,0,1-1.87-8.6c.814,0,1.3.418,1.034,1.474l-1.3,5.236c-.154.66-.4.858-1.43.968L-3.806,0ZM16.456-15.51a1.9,1.9,0,0,0-1.98,1.892,1.733,1.733,0,0,0,1.848,1.76,1.927,1.927,0,0,0,2.046-1.87A1.82,1.82,0,0,0,16.456-15.51ZM15.884,0l.242-.924c-.99-.11-1.122-.308-.968-.968l2.134-8.58H16.016L12.188-8.624l-.22.858h.682c.4,0,.484.2.352.66L11.7-1.892c-.154.66-.4.858-1.408.968L10.054,0ZM24.4-1.408a4.463,4.463,0,0,1-1.3.22c-.748,0-1.056-.418-.792-1.5l1.518-6.05H26.2l.352-1.408H24.178l.836-3.322H23.738a7.275,7.275,0,0,1-4.356,3.872l-.2.858h1.21L18.9-2.706c-.55,2.2.418,3.014,2.662,3.014a9.661,9.661,0,0,0,2.486-.374ZM37.18-5.654c.55-3.036-1.232-4.818-4.4-4.818A6.092,6.092,0,0,0,26.532-4.18c0,2.53,2.024,4.51,5.214,4.51,2.354,0,3.894-1.056,5.3-3.168L35.97-3.586C34.848-2,33.55-1.144,32.208-1.144c-1.474,0-2.266-.858-2.266-2.464a9.835,9.835,0,0,1,.22-2.046Zm-6.6-1.408c.462-1.166,1.232-2.09,2.332-2.09s1.672.726,1.386,2.09Z"
          transform="translate(40 22)"
          fill="#0c90cb"
        />
      </g>
    </svg>
  );
}

export default LumiteIcon;
